export default __webpack_public_path__ + "static/media/hills-bottom.575a11e8.svg";